export function normalizeAndRemoveDiacritics(input: string) {
  return input.normalize('NFD').replaceAll(/([\u0300-\u036f]|\s)+/g, '');
};
